import React, { useContext, useEffect, useState } from "react";
import { Button, Container } from "reactstrap";
import Header from "../../components/Headers/Header";
import AdminNavbar from "../../components/Navbars/AdminNavbar/AdminNavbar";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import Dashboard from "../../components/Dashboard/Dashboard";
import { useLocation, useParams } from "react-router-dom";
import { DocumentTypeContext } from "../../context/DocumentContext";
import ModalComponent from "../../components/ModalComponent/ModalComponent";
import { BigButton } from "../../components/PdfEditor/BigButton";
import { getQueryParam } from "../../utils/getQueryOaram";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import "./SignDocument.css";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import { UserTypeContext } from "../../context/UserTypeContext";
import { AuthContext } from "../../context/AuthContext";
import api from "../../api";
import { UserToken } from "../../context/hooks/useAuth";
import { jwtDecode } from "jwt-decode";
import { useToast } from "../../context/ToastContext";

const SignDocument = () => {
  const location = useLocation();
  const showToast = useToast();
  const { getDocumentSign, setInfoSign, getSigners, signers } =
    useContext(DocumentTypeContext);
  const { getUsersById, getUserIp, formValuesUsers } =
    useContext(UserTypeContext);
  const { decryptToken } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const url = window.location.href;
  const urlObj = new URL(url);

  let objUserTk: UserToken;
  if (localStorage.getItem("token")) {
    objUserTk = jwtDecode(localStorage.getItem("token") || "");
  } else {
    objUserTk = {} as UserToken;
  }

  useEffect(() => {
    let token = urlObj.searchParams.get("token");
    const documentId = urlObj.searchParams.get("documentId");
    const toPainel = urlObj.searchParams.get("sign");
  
    token = decodeURIComponent(token || "").replace(/ /g, "+");
  
    let errorShown = false;
  
    const showSingleError = () => {
      if (!errorShown) {
        showToast("error", "Contrato expirado ou inválido. Entre em contato com o proprietário do documento.");
        errorShown = true;
      }
    };
  
    const getDocument = async () => {
      if (token) {
        setPageLoading(true);
        const result = await decryptToken(token);
  
        if (result?.data?.data) {
          const { documentId, userId } = result.data.data;
          setInfoSign(result.data.data);
  
          try {
            await Promise.all([
              getDocumentSign(documentId, true),
              getSigners(documentId, true),
              getUsersById(userId, true)
            ]);
          } catch (error) {
            showSingleError();
          }
  
          await getUserIp();
        } else {
          showSingleError();
        }
        setPageLoading(false);
      }
    };
  
    const getDocumentById = async () => {
      if (documentId) {
        setPageLoading(true);
        try {
          await Promise.all([
            getDocumentSign(documentId, true),
            getSigners(documentId, true),
            getUsersById(objUserTk.UserId, true)
          ]);
  
          if (toPainel) {
            setInfoSign({ documentId, userId: objUserTk.UserId });
            await getUserIp();
          }
        } catch (error) {
          showSingleError();
        }
        setPageLoading(false);
      }
    };
  
    if (token) {
      getDocument();
    } else if (documentId) {
      getDocumentById();
    }
  }, []);
  
  const hasSigned = signers.find(
    (x: any) => x.name === formValuesUsers.email
  )?.hasSigned;

  if (pageLoading) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          gap: "20px",
          backgroundColor: "#f5f5f5",
        }}
      >
        <div
          style={{
            width: 48,
            height: 48,
            border: "4px solid #e0e0e0",
            borderTop: "4px solid #F9B233",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <span style={{ color: "#666", fontSize: 15, fontWeight: 500 }}>
          Carregando documento...
        </span>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <>
      <LoadingSpinner />
      <div
        className="header"
        style={{
          backgroundColor: "#0000001A",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "10px",
          boxSizing: "border-box",
        }}
      >
        <img
          className="sign-document-logo"
          alt="Logo"
          src={require("../../assets/img/brand/Simbolo_Negativa_sf.png")}
        />
        {urlObj.searchParams.get("documentId") &&
        urlObj.searchParams.get("sign") === "true" ? (
          <div>
            <Button
              onClick={() => window.history.back()}
              className="my-4 mr-4 button-back-sign-document"
              type="button"
            >
              <ArrowBackIosNewIcon />
              Voltar
            </Button>

            <Button
              disabled={hasSigned}
              onClick={() => setOpen(true)}
              className="my-4 mr-4 button-back-sign-document"
              type="button"
            >
              <CreateOutlinedIcon />
              Assinar
            </Button>
          </div>
        ) : urlObj.searchParams.get("documentId") ? (
          <Button
            onClick={() => window.history.back()}
            className="my-4 mr-4 button-back-sign-document"
            type="button"
          >
            <ArrowBackIosNewIcon />
            Voltar
          </Button>
        ) : (
          <Button
            disabled={hasSigned}
            onClick={() => setOpen(true)}
            className="my-4 mr-4 button-back-sign-document"
            type="button"
          >
            <CreateOutlinedIcon />
            Assinar
          </Button>
        )}
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          gap: "20px",
          padding: "20px",
          flexWrap: "wrap",
        }}
      >
        {/* Card dos Signatários */}
        <div
          style={{
            flex: "1",
            maxWidth: "350px",
            borderRadius: "10px",
            padding: "20px",
            backgroundColor: "#fff",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            minWidth: "300px",
            marginTop: "66px",
          }}
        >
          <h3
            style={{
              textAlign: "center",
              marginBottom: "20px",
              fontSize: "18px",
              color: "#75788D",
              marginTop: "10px",
              fontWeight: "bold",
            }}
          >
            Signatários
          </h3>

          {signers?.length > 0 &&
            signers.map((signer: any, index: any) => (
              <div
                key={index}
                className="signer-card"
                style={{
                  borderRadius: "10px",
                  padding: "15px",
                  backgroundColor: "#f9f9f9",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  marginBottom: "10px",
                }}
              >
                <span style={{ fontSize: "16px", color: "#333" }}>
                  {signer.email} - {signer.name}
                </span>
                <div style={{ marginTop: "10px" }}>
                  <span
                    style={{
                      color: signer.hasSigned ? "#155724" : "#721c24",
                    }}
                  >
                    {signer.hasSigned ? "Assinado" : "Pendente"}
                  </span>
                </div>
              </div>
            ))}
        </div>

        <div
          style={{
            flex: "2",
            width: "100%",
            maxWidth: "900px",
            padding: "0 20px",
          }}
        >
          <Container className="mt-5">
            <Dashboard />
          </Container>
        </div>
      </div>

      <ModalComponent openModal={open} closeModal={() => setOpen(false)} />

      <style>
        {`
      @media (max-width: 768px) {
        div[style*="flex-direction: row"] {
          flex-direction: column !important;
          align-items: center !important;
        }

        div[style*="flex: 2"] {
          width: 100% !important;
          max-width: 100% !important;
        }

        div[style*="flex: 1"] {
          width: 100% !important;
          max-width: 100% !important;
        }
      }
    `}
      </style>
    </>
  );
};

export default SignDocument;
